import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutExtraPayCompare extends Layout {
    labelChanges: Label;
    labelExtraPayAddsAndDeletes: Label;
    sourceCompareChangeGroup: DataSource;
    sourceEdiCompareItemChanges: DataSource;
    sourceExtraPayCompareGroup: DataSource;
    tableDriverExtraPay: Table;
    tableEPChanges: Table;
}
